import { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";

type State = "checking" | "allowed" | "denied";

/**
 * Guarda de rota: só renderiza o conteúdo para usuários autenticados
 * que possuam o papel "admin". Qualquer outro caso vai para /auth.
 */
const RequireAdmin = ({ children }: { children: React.ReactNode }) => {
  const [state, setState] = useState<State>("checking");
  const location = useLocation();

  useEffect(() => {
    let active = true;

    const check = async () => {
      try {
        const { data: { user } } = await supabase.auth.getUser();
        if (!user) {
          if (active) setState("denied");
          return;
        }

        const { data, error } = await supabase
          .from("user_roles")
          .select("role")
          .eq("user_id", user.id)
          .eq("role", "admin")
          .maybeSingle();

        if (error) throw error;
        if (active) setState(data ? "allowed" : "denied");
      } catch {
        if (active) setState("denied");
      }
    };

    check();

    const { data: { subscription } } = supabase.auth.onAuthStateChange(() => {
      setState("checking");
      check();
    });

    return () => {
      active = false;
      subscription.unsubscribe();
    };
  }, []);

  if (state === "checking") {
    return (
      <div className="min-h-screen flex items-center justify-center text-muted-foreground">
        Verificando acesso...
      </div>
    );
  }

  if (state === "denied") {
    return <Navigate to="/auth" replace state={{ from: location.pathname }} />;
  }

  return <>{children}</>;
};

export default RequireAdmin;
